import {makeObservable, observable, action} from 'mobx';

class UnityStore {
    loadUnity = false;
    isActive = false;
    roomID = 0;
    avatarUrl = '';
    mouseOn = false;
    isVideoActive = false;
    portalId = 0;
    audioTrack = null;
    screenTrack = null;
    enabledScreen = true;
    env = {};
    webGlContext = null;
    remoteUsersScreen = null;
    allUsers = null;
    currentStep = 0;
    endStep = 0;
    isActiveMobile = false;
    hooryToken = "fT6GazpERJe2ZMcNCmAyYByp";
    totalLikes = 0;
    isLiked = false;
    controlsPanelToggle = false;
    toggleScreen = false;
    blockHooryClicks = false

    constructor() {
        makeObservable(this, {
            loadUnity: observable,
            isActive: observable,
            mouseOn: observable,
            avatarUrl: observable,
            roomID: observable,
            isVideoActive: observable,
            portalId: observable,
            audioTrack: observable,
            screenTrack: observable,
            enabledScreen: observable,
            env: observable,
            webGlContext: observable,
            remoteUsersScreen: observable,
            allUsers: observable,
            isActiveMobile: observable,
            hooryToken: observable,
            totalLikes: observable,
            isLiked: observable,
            controlsPanelToggle: observable,
            toggleScreen: observable,
            blockHooryClicks: observable,
            setLoadUnity: action.bound,
            setMouseOn: action.bound,
            setRoomID: action.bound,
            setAvatarUrl: action.bound,
            setIsActive: action.bound,
            setIsVideoActive: action.bound,
            setPortalId: action.bound,
            setAudioTrack: action.bound,
            setScreenTrack: action.bound,
            setEnabledScreen: action.bound,
            setEnv: action.bound,
            setWebGlContext: action.bound,
            setAllUsers: action.bound,
            currentStep: observable,
            endStep: observable,
            setCurrentStep: action.bound,
            setEndStep: action.bound,
            setIsActiveMobile: action.bound,
            setHooryToken: action.bound,
            setTotalLikes: action.bound,
            setIsLiked: action.bound,
            returnCurrentToken: action.bound,
            setRoomToken: action.bound,
            returnRoomToken: action.bound,
            setControlsPanelToggle: action.bound,
            clearUnityData: action.bound,
            setToggleScreen: action.bound,
            setBlockHooryClicks: action.bound,
        });
    }

    setCurrentStep(step) {
        this.currentStep = step;
    }

    setEndStep(step) {
        this.endStep = step;
    }

    setLoadUnity(flag) {
        this.loadUnity = flag;
    }

    setWebGlContext(data) {
        this.webGlContext = data;
    }

    setIsActive(flag) {
        this.isActive = flag;
    }

    setMouseOn(flag) {
        this.mouseOn = flag;
    }

    setRoomID(number) {
        this.roomID = number;
    }

    setAvatarUrl(path) {
        this.avatarUrl = path;
    }

    setIsVideoActive(flag) {
        this.isVideoActive = flag;
    }

    setPortalId(num) {
        this.portalId = num;
    }

    setAudioTrack(track) {
        this.audioTrack = track;
    }

    setScreenTrack(track) {
        this.screenTrack = track;
    }

    setEnabledScreen(flag) {
        this.enabledScreen = flag;
    }

    setEnv(data) {
        this.env = data;
    }

    setRemoteUsersScreen(data) {
        this.remoteUsersScreen = data;
    }

    setAllUsers(data) {
        this.allUsers = data;
    }

    setIsActiveMobile(bool) {
        this.isActiveMobile = bool;
    }

    setHooryToken(str) {
        this.hooryToken = str;
    }

    setRoomToken(str) {
        this.roomToken = str;
    }

    returnRoomToken() {
        return this.roomToken;
    }

    returnCurrentToken() {
        return this.hooryToken;
    }

    setTotalLikes(num) {
        this.totalLikes = num;
    }

    setIsLiked(bool) {
        this.isLiked = bool;
    }
    setControlsPanelToggle(bool) {
        this.controlsPanelToggle = bool;
    }

    setToggleScreen(bool) {
        this.toggleScreen = bool;
    }

    setBlockHooryClicks(bool) {
        this.blockHooryClicks = bool
    }
    clearUnityData() {
        this.isActive = false;
        this.roomID = 0;
        this.mouseOn = false;
        this.isVideoActive = false;
        this.portalId = 0;
        this.audioTrack = null;
        this.screenTrack = null;
        this.enabledScreen = true;
        this.remoteUsersScreen = null;
        this.allUsers = null;
        this.currentStep = 0;
        this.endStep = 0;
        this.isActiveMobile = false;
        this.hooryToken = "";
        this.totalLikes = 0;
        this.isLiked = false;
        this.toggleScreen = false;
    }
}

export const unityStore = new UnityStore();
